// Mirrors the server's list kinds (admin-creations.controller.ts VALID_KINDS):
// a Studio story (`studio_stories`) and a character (`user_characters`), the
// two main things a creator makes; a v1 story (a `creations` row with kind
// "story", listed as "v1-story"); and the Story Studio's `creations` items. A
// kind offered here that the server does not know is dropped from the filter
// there. (No "library" kind since server 0092: a creator's small values are
// rows of their own tables.)
export const CREATION_KINDS = [
  "story",
  "character",
  "v1-story",
  "world",
  "voice",
  "style",
  "draft",
  "bin",
] as const;

/** The only kind the server lets the panel edit or delete. */
export const V1_STORY_KIND = "v1-story";

export const kindColor = (kind: string): "default" | "primary" | "secondary" | "success" => {
  switch (kind) {
    case "story":
      return "success";
    case "character":
      return "secondary";
    case V1_STORY_KIND:
      return "default";
    default:
      return "primary";
  }
};

export const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};
